import { ApiService } from "@/services/api/ApiService";
import { PreselectedVoice, PreselectedVoiceInput } from "@/types/voice/preselected-voice";

export class PreselectedVoiceService {
  static async list(): Promise<PreselectedVoice[]> {
    const response = await ApiService.invoke<{ voices: PreselectedVoice[] }>({
      resource: "preselected-voices",
      action: "all",
    });
    return response.voices ?? [];
  }

  static async create(input: PreselectedVoiceInput): Promise<PreselectedVoice> {
    const response = await ApiService.invoke<{ voice: PreselectedVoice }>({
      resource: "preselected-voices",
      action: "create",
      data: input,
    });
    return response.voice;
  }

  static async update(id: string, input: Partial<PreselectedVoiceInput>): Promise<PreselectedVoice> {
    const response = await ApiService.invoke<{ voice: PreselectedVoice }>({
      resource: "preselected-voices",
      action: "update",
      id,
      data: input,
    });
    return response.voice;
  }

  static async delete(id: string): Promise<void> {
    await ApiService.invoke({
      resource: "preselected-voices",
      action: "delete",
      id,
    });
  }
}
